<h1 mat-dialog-title>
  {{ dialogHeader }}
</h1>

<div mat-dialog-content>
  {{ dialogText }}
</div>

<div mat-dialog-actions>
  <button (click)="closeDialog()" mat-raised-button type="button">
    {{ 'common.buttons.cancel' | transloco }}</button>
  <button (click)="deleteAction()" mat-raised-button type="submit"
    color="warn">{{ confirmButtonLabel ?? ('common.buttons.delete' | transloco) }}</button>
</div>
